import React, { useMemo } from 'react';
import { Route } from 'react-router-dom';
import { linkWhereFrom } from '@/common/utils/helper';
import IFrame from '@/components/iframe';
import env from '@/env';
import Header from '@/components/outest-layout/header';
import TfLaunch from '@/micro-app/tf-launch';
import TfMaterial from '@/micro-app/tf-material';
import RoutesMaterials from '@/pages/materials/routes';

function globalContainer(Body) {
  return React.memo(function (props) {
    return (
      <>
        <Header />
        <Body {...props} />
      </>
    );
  });
}

// 使用IFrame内嵌潘多拉页面
function Pandora() {
  const hash = useMemo(() => location.hash, []);
  return <IFrame src={linkWhereFrom(`${env.ACE_DOMAIN}/pandora/${hash}`)} />;
}

const PageTfLaunch = globalContainer(TfLaunch);
const PageTfMaterial = globalContainer(TfMaterial);
const PagePandora = globalContainer(Pandora);

export default function globalRoutes() {
  return [
    // <Route component={PageTfLaunch} path="/launch/*" key="lanunch/*" />,
    // <Route component={PageTfLaunch} path="/launch" key="lanunch" />,

    // <Route component={PageTfMaterial} path="/material/*" key="material/*" />,
    // <Route component={PageTfMaterial} path="/material" key="material" />,

    <Route component={PagePandora} path="/pandoraacore/*" key="acorepandora/*" />,
    <Route component={PagePandora} path="/pandoraacore" key="acorepandora" />,

    <Route component={RoutesMaterials} path="/materials/*" key="/materials/*" />,
  ];
}
